<mat-nav-list>
  <a [href]="data.href" mat-list-item target="_blank" rel="noopener">
    <span mat-line>{{ 'LinkShareHandler.GoToLink' | translate }}</span>
  </a>

  <a [cdkCopyToClipboard]="data.href" mat-list-item>
    <span mat-line>{{ 'LinkShareHandler.CopyLink' | translate }}</span>
  </a>

  <a href="https://t.me/share/url?url={{data.href}}&text={{ 'LinkShareHandler.RedirectionMessage' | translate }}" mat-list-item target="_blank" rel="noopener">
    <span mat-line>{{ 'LinkShareHandler.SendToTelegram' | translate }}</span>
  </a>

  <a href="https://api.whatsapp.com/send?text={{data.href}} - {{ 'LinkShareHandler.RedirectionMessage' | translate }}" mat-list-item target="_blank" rel="noopener">
    <span mat-line>{{ 'LinkShareHandler.SendToWhatsup' | translate }}</span>
  </a>
</mat-nav-list>